"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var Image_1 = require("ContentTokens/DataModels/Image");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var frameOptions = function () {
    return [
        {
            label: "none",
            value: Image_1.ImageFrame.None,
            icon: react_1.default.createElement(icons_1.FrameNone, null),
            tooltipMessage: "No frame",
        },
        {
            label: "circle",
            value: Image_1.ImageFrame.Circle,
            icon: react_1.default.createElement(icons_1.FrameCircle, null),
            tooltipMessage: "Circle frame",
        },
    ];
};
var ImageFramePanel = (function (_super) {
    __extends(ImageFramePanel, _super);
    function ImageFramePanel(props) {
        var _this = _super.call(this, props) || this;
        _this.selectFrameType = function (selectedValue) {
            if (_this.isValidFrameType(selectedValue)) {
                _this.props.telemetry.changedImageFrame(selectedValue);
                _this.props.onFrameSelect(selectedValue);
            }
        };
        _this.isValidFrameType = function (value) {
            return Object.values(Image_1.ImageFrame).includes(value.toString());
        };
        return _this;
    }
    ImageFramePanel.prototype.render = function () {
        var _a = this.props, frameType = _a.frameType, startReposition = _a.startReposition;
        return (react_1.default.createElement(kaleidoscope_2.Panel, { theme: kaleidoscope_2.PanelTheme.Dark, className: (0, classnames_1.default)("image-frame-panel", {
                "image-frame-panel--full-height": frameType === Image_1.ImageFrame.Circle,
            }) },
            react_1.default.createElement("div", { className: "image-frame-panel__label" }, "Image frame"),
            react_1.default.createElement("div", { className: "image-frame-panel__item" },
                react_1.default.createElement(kaleidoscope_3.OptionGroup, { size: kaleidoscope_1.OptionGroupSize.Small, options: frameOptions(), selectedValue: frameType, onClickHandler: this.selectFrameType })),
            react_1.default.createElement(kaleidoscope_3.Button, { type: kaleidoscope_3.ButtonType.Tertiary, className: (0, classnames_1.default)("image-frame-panel__button", {
                    "image-frame-panel__button--hide": frameType !== Image_1.ImageFrame.Circle,
                }), width: "full", size: kaleidoscope_3.ButtonSize.Small, onClick: startReposition }, "Reposition in frame")));
    };
    ImageFramePanel = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], ImageFramePanel);
    return ImageFramePanel;
}(react_1.default.Component));
exports.default = ImageFramePanel;
